module.exports = __webpack_public_path__ + "static/media/TowerIconGreen.92c04264.svg";